import { render, staticRenderFns } from "./LazyGameList.vue?vue&type=template&id=2103c3ef&scoped=true"
import script from "./LazyGameList.vue?vue&type=script&lang=js"
export * from "./LazyGameList.vue?vue&type=script&lang=js"
import style0 from "./LazyGameList.vue?vue&type=style&index=0&id=2103c3ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103c3ef",
  null
  
)

export default component.exports